export default "__VITE_ASSET__CeZoZ7qc__"